"use client";

import React from 'react';

interface SimpleLoaderProps {
  isLoading: boolean;
  title?: string;
  subtitle?: string;
}

const SimpleLoader: React.FC<SimpleLoaderProps> = ({
  title = 'Loading Your Page...',
  subtitle,
  isLoading = true,
}) => {
  if (!isLoading) return null;

  return (
    <>
      <style>
        {`
          @keyframes fadeDot {
            0%, 80%, 100% {
              opacity: 0.2;
              transform: scale(0.8);
            }
            40% {
              opacity: 1;
              transform: scale(1);
            }
          }
          .simple-loader-dot {
            animation: fadeDot 1.4s ease-in-out infinite;
          }
          .simple-loader-dot-delay1 {
            animation: fadeDot 1.4s ease-in-out infinite 0.2s;
          }
          .simple-loader-dot-delay2 {
            animation: fadeDot 1.4s ease-in-out infinite 0.4s;
          }
        `}
      </style>

      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
          padding: '24px',
          maxWidth: '320px',
          width: '100%',
          margin: '0 16px'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: '16px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              <div
                className="simple-loader-dot"
                style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#F1546B',
                  borderRadius: '50%'
                }}
              />
              <div
                className="simple-loader-dot-delay1"
                style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#F1546B',
                  borderRadius: '50%'
                }}
              />
              <div
                className="simple-loader-dot-delay2"
                style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#F1546B',
                  borderRadius: '50%'
                }}
              />
            </div>

            {title && (
              <h2 style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#1f2937',
                margin: 0
              }}>
                {title}
              </h2>
            )}

            {subtitle && (
              <p style={{
                fontSize: '12px',
                color: '#6b7280',
                margin: 0
              }}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SimpleLoader;
